<template>
    <v-main :style="{backgroundColor: $vuetify.theme.themes.light.backgroundOryx}">
        <v-container :fluid="!$route.meta.reduced" fill-height class="align-start justify-center" :style="$route.meta.reduced ? $route.name == 'product' ? 'max-width: 1024px' : 'max-width: 672px' : ''">
            <router-view></router-view>
        </v-container>
    </v-main>
</template>

<script>
export default {
};
</script>

<style>
</style>